<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ActionsBar',
  props: {
    actionButtons: {
      type: Array,
      default: () => [],
    },
    contrastStyle: {
      type: String,
      default: () => '',
    },
  },
  emits: ['set'],
  setup(_, { emit }) {
    return {
      showConfigType(type: string) {
        emit('set', type)
      },
    }
  },
})
</script>

<template>
  <q-virtual-scroll
    v-slot="{ item }"
    virtual-scroll-horizontal
    :items="actionButtons"
    class="actions-wrapper"
  >
    <div class="column items-center q-mt-sm">
      <q-btn
        :key="item.type"
        class="action-item text-caption q-mx-sm" :class="[
          { 'hover-zoom': !item.disabled },
          { 'action-item--disabled': item.disabled },
        ]"
        color="white"
        :disabled="item.disabled"
        :glossy="!item.disabled"
        :unelevated="item.disabled"
        round
        padding="xs"
        @click="showConfigType(item.type)"
      >
        <span v-hoist v-html="item.icon" />
      </q-btn>
      <span
        class="text-caption text-shadow" :class="[`text-${contrastStyle}`]"
        v-html="item.label"
      />
    </div>
  </q-virtual-scroll>
</template>
